var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyInbox = function SvgEmptyInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 72",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72.1,71.2H3.6c-1.6,0-2.8-1.3-2.8-2.8V44.3l8.6-24.6c0.4-1.1,1.5-1.9,2.7-1.9h51.6c1.2,0,2.3,0.8,2.7,1.9L75,44.3v24.1 C75,70,73.7,71.2,72.1,71.2z M3.2,44.7v23.7c0,0.2,0.1,0.3,0.3,0.3h68.6c0.2,0,0.3-0.1,0.3-0.3V44.7L64,20.5c0-0.1-0.2-0.2-0.3-0.2 H12.1c-0.1,0-0.3,0.1-0.3,0.2L3.2,44.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.8,57.9c-6.8,0-12.3-5.4-12.3-12.1c0-0.1,0-0.4,0-0.5c0,0-0.1,0-0.4,0H9.9c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2H25 c1.1,0,2.9,0.4,2.9,3.1c0,5.3,4.4,9.6,9.8,9.6c5.4,0,9.8-4.3,9.8-9.6c0-2.7,1.8-3.1,2.9-3.1h20.4c0.7,0,1.2,0.6,1.2,1.2 s-0.6,1.2-1.2,1.2H50.5c-0.3,0-0.4,0.1-0.4,0.1c0,0.1,0,0.4,0,0.5C50.1,52.5,44.6,57.9,37.8,57.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.5,10.8c-0.3,0-0.6-0.1-0.8-0.3c-0.5-0.5-0.6-1.2-0.1-1.8l5-5.6C55,2.6,55.8,2.6,56.3,3c0.5,0.5,0.6,1.2,0.1,1.8 l-5,5.6C51.2,10.7,50.8,10.8,50.5,10.8z M23.5,10.8c-0.3,0-0.7-0.1-0.9-0.4l-5-5.6c-0.5-0.5-0.4-1.3,0.1-1.8 c0.5-0.5,1.3-0.4,1.8,0.1l5,5.6c0.5,0.5,0.4,1.3-0.1,1.8C24.1,10.7,23.8,10.8,23.5,10.8z M37.1,10.8c-0.7,0-1.2-0.6-1.2-1.2V2 c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v7.6C38.3,10.2,37.7,10.8,37.1,10.8z"
  })))));
};
export default SvgEmptyInbox;